module.exports = __webpack_public_path__ + "static/media/DuplicateSans-Italic.78663a07.woff";